/**
 *
 * Jira Table
 *
 */

import React, { memo, useEffect } from 'react';

import { Clients } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { renderTimeStackedCell, WithResourceIcon } from 'components/index';
import { DeleteClientModal } from 'containers/Setup/Integrations/Components/Utils/DeleteClientModal';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions as clientActions } from '../../../../slice';

export const JiraTable = memo(() => {
  const { clients, client } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const { clientActionsColumn, ...rest } = useIntegrations();

  useEffect(() => {
    dispatch(
      clientActions.loadClients({
        clientName: Clients.Jira,
      }),
    );
  }, [dispatch]);

  const columns = [
    {
      header: <Box pl={12}>Connector Name</Box>,
      accessor: 'name',
      render: ({ value }) => (
        <WithResourceIcon
          resourceType={Clients.Jira}
          iconFilled={false}
          spacing={6}
          iconSize="regular"
        >
          {value}
        </WithResourceIcon>
      ),
    },
    {
      header: 'Project',
      accessor: 'jira.project_name',
      align: 'left',
    },
    {
      header: 'Default Board',
      accessor: 'jira.default_board_name',
      align: 'left',
    },
    /*{
      header: 'Default Assignee',
      accessor: 'jira.default_board_name',
      align: 'left',
    },*/
    {
      header: 'User ID',
      accessor: 'jira.user',
      align: 'left',
    },
    {
      header: 'URL',
      accessor: 'jira.url',
      align: 'left',
    },
    {
      header: 'Created By',
      accessor: 'created_by',
      align: 'left',
    },
    {
      header: 'Created At',
      accessor: 'created_at',
      render: renderTimeStackedCell,
      align: 'left',
    },
    clientActionsColumn,
  ];

  return (
    <>
      <Table
        columns={columns}
        data={clients.jira}
        isLoading={clients.loading || client.isLoading}
      />
      {rest.isOpenDeleteClientModal && (
        <DeleteClientModal label="Delete JIRA Project" {...rest} />
      )}
    </>
  );
});
